export class AppRouter {
  static use() {
    const router = useRouter()

    return {
      ...router
    }
  }
}
